import { Component, OnInit,Input } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  // { path: '/branch', title: 'Branch', icon: 'route', class: '' },
  { path: '/superadmin/company', title: 'Company', icon: 'account_balance', class: '' },
  // { path: '/superadmin/permisson', title: 'Permisson', icon: 'https', class: '' },
  // { path: '/superadmin/role', title: 'Role', icon: 'accessibility', class: '' },
  // { path: '/superadmin/group', title: 'Group', icon: 'group', class: '' },
  { path: '/superadmin/user', title: 'Users', icon: 'group', class: '' },
  { path: '/superadmin/legal_entity', title: 'Legal Entity', icon: 'home', class: '' },
  { path: '/superadmin/unit_master' ,title: 'Unit', icon: 'library_books', class: ''},
  { path: '/superadmin/global-gst-master' ,title: 'GST', icon: 'library_books', class: ''},
  { path: '/superadmin/global-service-master' ,title: 'Service', icon: 'library_books', class: ''},
  { path: '/superadmin/hsn-sac-master' ,title: 'HSN/SAC', icon: 'library_books', class: ''},
  { path: '/superadmin/item_master' ,title: 'Item', icon: 'library_books', class: ''},
  { path: '/superadmin/all-user' , title: 'All Users' , icon: 'library_books', class: ''},
  { path: '/superadmin/changelog' , title: 'Changelog' , icon: 'library_books', class: ''},
];

@Component({
  selector: 'app-superadmin-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  @Input() isCollapsed: boolean = false;
  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };
}
